<template>
  <div>
    <loader :loader="sending" />
    <v-data-table :headers="headers" :items="listHistoy" :items-per-page="itemsPerPage" :search="search"
      no-data-text="Sin resultados disponibles" class="mx-5" dense fixed-header height="auto" hide-default-footer>
      <template v-slot:[`item.intepretationDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.intepretationDate) }}
      </template>
      <template v-slot:[`item.startDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.startDate) }}
      </template>
      <template v-slot:[`item.nameInterpreter`]="{ item }">
        <span>
          {{ item.nameInterpreter }}
          <span v-if="item.validatorName !== ''">
            <br />
            <small style="font-style: italic; font-weight: bold;">Validó: <br /> {{ item.validatorName }}</small>
          </span>
        </span>
      </template>
      <template v-slot:[`item.birads`]="{ item }">
        <v-chip :color="item.colorBirads" small>
          {{ item.birads }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small icon @click="exportToPDF(item)">
              <v-icon color="error" v-bind="attrs" v-on="on">
                mdi-file-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span> Descargar PDF </span>
        </v-tooltip>
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn small icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>Más opciones</span>
            </v-tooltip>
          </template>
          <!-- getDataEdit(item) -->
          <v-list dense>
            <v-list-item link @click="isEditableTable(item)" 
              v-if="$utilFront.withPermission($prm.INTERPRETATION_EDIT_ALL)">
              <v-list-item-icon>
                <v-icon color="warning"> mdi-pencil </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Editar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="downloadViewer(item.idStudy)">
              <v-list-item-icon>
                <v-icon color="amber"> mdi mdi-comment-eye </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Visualizador </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="downloadZIP(item)" v-if="$utilFront.withPermission($prm.DOWNLOAD_DICOM_INT)">
              <v-list-item-icon>
                <v-icon color="secondary"> mdi-folder-download </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> DICOM </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="changeViewAddendums(item)">
              <v-list-item-icon>
                <v-icon color="cyan"> mdi-file-image </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Archivos anexos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <view-image-item :send="() => sending = !sending" :sending="sending" :idStudy="item.idStudy"
              v-if="$utilFront.withPermission($prm.VIEWER_WEB_INT)" />

          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <v-card-actions align="center">
      <v-col>
        <v-btn outlined small color="green darken-1" :disabled="sending" @click="downloadReportXLSX()">
          {{ sending ? "Exportando..." : "Exportar interpretaciones" }}
          <v-icon right>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-col>
    </v-card-actions>
    <v-dialog v-model="dialogCancelation" persistent max-width="70%" v-if="dialogCancelation">
      <cancelation-modal :dataModal="dataModal" @closeCancelationDialog="closeCancelationDialog"
        :dialogCancelation="dialogCancelation" />
    </v-dialog>
  </div>
</template>

<script>

import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import ViewImageItem from "@/app/components/common/study/ViewImageItem.vue";
import ColposcopyForm from "@/core/request/ColposcopyForm";
import { InterpretationHistoryService } from "@/app/services";

import {
  ReportPDFRequest,
  DownloadZipRequest,
  StudyRequest,
} from "@/core/request";
export default {
  name: "SpecialityTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    itemsPerPage: Number,
    biRadsSelect: Number,
    listAllPagination: Function,
    getAddendums: Function,
    search: String,
    range: Object,
    idBranchOffice: String,
    modalitiesSelect: String,
  },
  components: {
    MenuCrud,
    CancelationModal,
    Loader,
    ViewImageItem
  },
  data() {
    return {
      dialogCancelation: false,
      dataModal: {},
      listHistoy: [],
      sending: false,
      headers: [
        {
          text: "Id Interpretación",
          value: "idInterpretation",
          sortable: false,
          align: "center",
        },
        {
          text: "Id Estudio",
          value: "idStudy",
          align: "center",
          sortable: false,
        },
        {
          text: "Nombre del paciente",
          value: "patient",
          sortable: false,
          align: "center",
        },
        {
          text: "Modalidad",
          value: "modality",
          sortable: false,
          align: "center",
        },
        {
          text: "Estudio",
          value: "studyModality",
          sortable: false,
          align: "center",
        },
        {
          text: "BI-RADS",
          value: "birads",
          sortable: false,
          align: "center",
        },
        {
          text: "Fecha de interpretación",
          value: "intepretationDate",
          sortable: false,
          align: "center",
        },
        {
          text: "Fecha del estudio",
          value: "startDate",
          sortable: false,
          align: "center",
        },
        {
          text: "Intérprete",
          value: "nameInterpreter",
          sortable: false,
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width:"8%"
        },
      ],
    };
  },
  watch: {
    list: function () {
      this.setlistWithBiradsChanges();
    },
  },
  methods: {
    setlistWithBiradsChanges() {
      this.listHistoy = this.list.map((obj) => {
        obj.birads = obj.birads ? obj.birads : "NA";
        obj.colorBirads = obj.colorBirads ? obj.colorBirads : "nobirad";
        return obj;
      });
    },
    isEditableTable(item) {
  if (item.modality && item.modality.toUpperCase() === 'COLPOSCOPIA') {
    const payloadQuestions = {
      evaluationTypes: [13],
      idPerson: item.idPerson,
      idStudy: item.idStudy
    };

    ColposcopyForm.editColposcopyFormFromInterpretation(payloadQuestions)
      .then((respColposcopy) => {
        const newData = respColposcopy.data;
        console.log("Respuesta del API:", newData);
        const mappedData = newData.map((calculator) => {
          const mappedQuestions = calculator.dataQuestions.map((q) => {
            if (q.typeAnswer === 2 && q.idAnswer) {
              q.answerClosed = q.idAnswer;
            }
            return q;
          });
          return {
            idEvaluation: calculator.idCalculator,
            name: calculator.name,
            description: calculator.name,
            key: calculator.idCalculator,
            type: calculator.type,
            questions: mappedQuestions,
          };
        });
        console.log("Datos mapeados para colposcopía:", mappedData);
        this.$emit("colposcopyLoaded", mappedData);
        return this.get(item.idInterpretation, 3);
      })
      .catch((error) => {
        this.$utilFront.errorhttp(error);
      });

  } else {
    this.get(item.idInterpretation, 3);
  }
},



    checkCancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      this.dataModal.birthDate = this.$utilFront.formatDate(
        this.dataModal.birthDate
      );
      this.dialogCancelation = true;
    },
    closeCancelationDialog(e) {
      this.dialogCancelation = e;
      this.deleteItem();
    },
    downloadViewer(item) {
      try {
        this.sending = true;
        let data = {
          idStudy: item,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
        };
        StudyRequest.findURLJNLP(data)
          .then((res) => {
            window.open(res.data, "_blank").focus();
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
    downloadZIP(item) {
      this.sending = true;
      try {
        let data = { idStudy: item.idStudy };
        DownloadZipRequest.downloadImagesDCM(data)
          .then((res) => {
            const url = URL.createObjectURL(
              new Blob([res.data], {
                type: "application/zip",
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", item.idStudy + ".zip");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
    exportToPDF(interpretation) {
      let data = {
        idInterpretation: interpretation.idInterpretation,
        interpretationText: "",
        fileName: "Interpretacion",
      };
      ReportPDFRequest.downloadInterpretation(data);
    },
    changeViewAddendums(item) {
      this.sending = true;
      this.objectInterpretation = item;
      this.getAddendums(item, 1);
    },
    downloadReportXLSX() {
      if (!this.sending) {

        this.sending = true;

        let params = {
          idBirads: this.biRadsSelect,
          search: this.search,
          idBranchOffice: this.idBranchOffice != null ? this.idBranchOffice : this.$utilFront.getIdBranchOffice(),
        };

        if (this.$utilFront.nonEmpty(this.modalitiesSelect)) {
          params.idModality = this.modalitiesSelect;
        }

        let rangeName = "";

        if (this.$utilFront.nonEmpty(this.range)) {
          params.start = this.$utilFront.startOfDay(this.range.start);
          params.end = this.$utilFront.endOfDay(this.range.end);
          rangeName = ` del ${this.$utilFront.formatDate(params.start)} al ${this.$utilFront.formatDate(params.end)}`;
        }




        let fileName = `Historial de interpretaciones${rangeName}.xlsx`;

        InterpretationHistoryService.downloadReportHistoryXLSX(params).then((response) => {
          let { data } = response;
          this.$utilFront.downloadXLSX(data, fileName);
        }).catch((error) => {
          this.$utilFront.errorhttp(error);
        }).finally(() => {
          this.sending = false;
        });
      }
    },
  },
};
</script>
